// AUTO-GENERATED GraphQL Builder for WeddingCard
import * as Builders from '../';
export class WeddingCardBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingId(){ return this.add('bookingId'); }
  customerId(){ return this.add('customerId'); }
  cardTemplateId(){ return this.add('cardTemplateId'); }
  coupleNames(){ return this.add('coupleNames'); }
  slug(){ return this.add('slug'); }
  eventDate(){ return this.add('eventDate'); }
  eventTime(){ return this.add('eventTime'); }
  eventSessionId(){ return this.add('eventSessionId'); }
  venueName(){ return this.add('venueName'); }
  venueAddress(){ return this.add('venueAddress'); }
  gpsLat(){ return this.add('gpsLat'); }
  gpsLng(){ return this.add('gpsLng'); }
  heroPhotoUrl(){ return this.add('heroPhotoUrl'); }
  isPublished(){ return this.add('isPublished'); }
  configJson(){ return this.add('configJson'); }
  status(){ return this.add('status'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  booking(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('booking'))return this;
    this.v.add('booking');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`booking { ${inner} }`);
    return this;
  }

  cardTemplate(b?:(q:Builders.CardTemplateBuilder)=>void){
    if(this.depth>=5||this.v.has('cardTemplate'))return this;
    this.v.add('cardTemplate');
    const n=new Builders.CardTemplateBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`cardTemplate { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  customer(b?:(q:Builders.CustomerBuilder)=>void){
    if(this.depth>=5||this.v.has('customer'))return this;
    this.v.add('customer');
    const n=new Builders.CustomerBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`customer { ${inner} }`);
    return this;
  }

  eventSession(b?:(q:Builders.EventSessionBuilder)=>void){
    if(this.depth>=5||this.v.has('eventSession'))return this;
    this.v.add('eventSession');
    const n=new Builders.EventSessionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`eventSession { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  cardRsvpList(b?:(q:Builders.CardRsvpBuilder)=>void){
    if(this.depth>=5||this.v.has('cardRsvpList'))return this;
    this.v.add('cardRsvpList');
    const n=new Builders.CardRsvpBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`cardRsvpList { ${inner} }`);
    return this;
  }

  cardWishList(b?:(q:Builders.CardWishBuilder)=>void){
    if(this.depth>=5||this.v.has('cardWishList'))return this;
    this.v.add('cardWishList');
    const n=new Builders.CardWishBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`cardWishList { ${inner} }`);
    return this;
  }

  checklistItemList(b?:(q:Builders.ChecklistItemBuilder)=>void){
    if(this.depth>=5||this.v.has('checklistItemList'))return this;
    this.v.add('checklistItemList');
    const n=new Builders.ChecklistItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`checklistItemList { ${inner} }`);
    return this;
  }

  checklistSectionList(b?:(q:Builders.ChecklistSectionBuilder)=>void){
    if(this.depth>=5||this.v.has('checklistSectionList'))return this;
    this.v.add('checklistSectionList');
    const n=new Builders.ChecklistSectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`checklistSectionList { ${inner} }`);
    return this;
  }

  reverseCardRsvp(b?:(q:Builders.CardRsvpBuilder)=>void){
    const n=new Builders.CardRsvpBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`cardRsvpList { ${inner} }`);
    return this;
  }

  reverseCardWish(b?:(q:Builders.CardWishBuilder)=>void){
    const n=new Builders.CardWishBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`cardWishList { ${inner} }`);
    return this;
  }

  reverseChecklistItem(b?:(q:Builders.ChecklistItemBuilder)=>void){
    const n=new Builders.ChecklistItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`checklistItemList { ${inner} }`);
    return this;
  }

  reverseChecklistSection(b?:(q:Builders.ChecklistSectionBuilder)=>void){
    const n=new Builders.ChecklistSectionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`checklistSectionList { ${inner} }`);
    return this;
  }
}
